﻿import L from 'leaflet';
import type { LayerSetupDefinition } from '../Map.types';

export interface ISidebarLayerControlProps {
    scope: string;
    map: L.Map;
    region: string;
    defaultSection: LayerSectionId;
    layers: { [key: string]: LayerSetupDefinition };
    defaultOnLayers: string[];
    sectionsToShow: LayerSectionId[];
    sectionHeaders?: { [key in LayerSectionId]?: string };
    roadHelpElementId?: string;
    bikePlannerUrl?: string;
    taPlanDescription?: string;
    taPlanContact?: string;
    /** Determines whether the sidebar should be open by default, defaults to true */
    defaultOpen?: boolean;
    /** When true, the active layer selection is persisted in the URL hash (shareable) instead of local storage. */
    persistLayersInUrl?: boolean;
    onLayerToggle?(layerId: string, action: 'add' | 'remove'): void;
    onLayerControlSectionChange?(sectionId: LayerSectionId): void;
}

export interface ISidebarLayerControlState {
    activeSection: LayerSectionId;
    open: boolean;
    layerUpdatePending?: boolean;
}

export const ROAD_SECTION = 'road-section',
    BIKE_SECTION = 'bike-section',
    ROAD_CONDITION_SECTION = 'road-condition-section',
    PARKING_SECTION = 'parking-section',
    TAPLAN_SECTION = 'ta-plan-section';

export type LayerSectionId =
    typeof ROAD_SECTION | typeof BIKE_SECTION | typeof ROAD_CONDITION_SECTION | typeof PARKING_SECTION | typeof TAPLAN_SECTION;
